'use strict';

/* global wc jQuery Stripe */

import PaymentElementBlock from './modules/PaymentElementBlock';

if ( typeof wc !== 'undefined' ) {
	new PaymentElementBlock();
}
